// Путь: D:\QR\QR-WEB\dashboard\src\components\User\VoucherCard.jsx
// Версия: 6.3.0 - Fixed themes, larger branding
// Дата: 16.12.2025

import React, { useState } from 'react';
import './VoucherCard.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://qr-money.onrender.com';

const THEME_MAP = {
  'default': '/templates/default.png',
  'обычный': '/templates/default.png',
  'birthday': '/templates/birthday.png',
  'день рождения': '/templates/birthday.png',
  'love': '/templates/love.png',
  'с любовью': '/templates/love.png',
  'thanks': '/templates/thanks.png',
  'спасибо': '/templates/thanks.png',
  'gift': '/templates/gift.png',
  'подарок': '/templates/gift.png',
  'congrats': '/templates/congrats.png',
  'поздравляю': '/templates/congrats.png',
  'coffee': '/templates/coffee.png',
  'на кофе': '/templates/coffee.png',
  'lunch': '/templates/lunch.png',
  'на обед': '/templates/lunch.png',
  'travel': '/templates/travel.png',
  'путешествие': '/templates/travel.png',
  'gaming': '/templates/gaming.png',
  'на игры': '/templates/gaming.png',
  'shopping': '/templates/shopping.png',
  'шоппинг': '/templates/shopping.png',
  'newyear': '/templates/newyear.png',
  'новый год': '/templates/newyear.png',
};

const THEME_TITLES = {
  'default': 'Thank You',
  'обычный': 'Thank You',
  'birthday': 'Happy Birthday!',
  'день рождения': 'Happy Birthday!',
  'love': 'With Love',
  'с любовью': 'With Love',
  'thanks': 'Thank You!',
  'спасибо': 'Thank You!',
  'gift': 'A Gift For You',
  'подарок': 'A Gift For You',
  'congrats': 'Congratulations!',
  'поздравляю': 'Congratulations!',
  'coffee': 'Coffee Time',
  'на кофе': 'Coffee Time',
  'lunch': 'Lunch Time',
  'на обед': 'Lunch Time',
  'travel': 'Bon Voyage!',
  'путешествие': 'Bon Voyage!',
  'gaming': 'Game On!',
  'на игры': 'Game On!',
  'shopping': 'Shopping Spree',
  'шоппинг': 'Shopping Spree',
  'newyear': 'Happy New Year!',
  'новый год': 'Happy New Year!',
};

const getTemplateUrl = (themeId) => {
  if (!themeId) return '/templates/default.png';
  const key = themeId.toLowerCase();
  return THEME_MAP[key] || '/templates/default.png';
};

const getThemeTitle = (themeId) => {
  if (!themeId) return 'QR Money';
  const key = themeId.toLowerCase();
  return THEME_TITLES[key] || 'QR Money';
};

const VoucherCard = ({ amount, code, templateTitle, voucherToken }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const templateUrl = getTemplateUrl(templateTitle);
  const title = getThemeTitle(templateTitle);

  const drawVoucherText = (ctx, SIZE) => {
    const center = SIZE / 2;
    
    ctx.fillStyle = '#ffffff';
    ctx.textAlign = 'center';
    ctx.shadowColor = 'rgba(0,0,0,0.6)';
    ctx.shadowBlur = 6;
    
    // Заголовок темы - 30%
    ctx.font = 'bold 80px Arial';
    ctx.fillText(title, center, SIZE * 0.30);
    
    // Сумма DAR - 48%
    ctx.font = 'bold 116px Arial';
    ctx.fillText(parseFloat(amount).toFixed(2) + ' DAR', center, SIZE * 0.48);
    
    // Брендинг dary.one - 64%
    ctx.shadowBlur = 5;
    ctx.font = 'bold 56px Arial';
    ctx.fillStyle = 'rgba(255,255,255,0.95)';
    ctx.fillText('🎁 → dary.one', center, SIZE * 0.64);

    // Код - 78%
    ctx.shadowColor = 'rgba(0,0,0,0.95)';
    ctx.shadowBlur = 20;
    ctx.font = 'bold 60px monospace';
    ctx.fillStyle = '#FFFFFF';
    ctx.fillText(code || '', center, SIZE * 0.78);
  };

  const handleDownload = async () => {
    if (isDownloading) return;
    setIsDownloading(true);

    const SIZE = 1024;
    const canvas = document.createElement('canvas');
    canvas.width = SIZE;
    canvas.height = SIZE;
    const ctx = canvas.getContext('2d');

    const img = new Image();
    img.crossOrigin = 'anonymous';
    
    img.onload = async () => {
      ctx.drawImage(img, 0, 0, SIZE, SIZE);
      drawVoucherText(ctx, SIZE);
      canvas.toBlob(async (blob) => {
        await saveVoucher(blob);
      }, 'image/png');
    };
    
    img.onerror = async () => {
      const gradient = ctx.createLinearGradient(0, 0, SIZE, SIZE);
      gradient.addColorStop(0, '#7C3AED');
      gradient.addColorStop(1, '#A78BFA');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, SIZE, SIZE);
      drawVoucherText(ctx, SIZE);
      canvas.toBlob(async (blob) => {
        await saveVoucher(blob);
      }, 'image/png');
    };
    
    img.src = templateUrl;
  };

  const saveVoucher = async (blob) => {
    try {
      if (voucherToken && voucherToken.length === 64) {
        const token = localStorage.getItem('authToken');
        const formData = new FormData();
        formData.append('image', blob, 'voucher.png');
        formData.append('voucherToken', voucherToken);

        const response = await fetch(API_URL + '/api/vouchers/encode-image', {
          method: 'POST',
          headers: { 'Authorization': 'Bearer ' + token },
          body: formData
        });

        const result = await response.json();

        if (result.success && result.data.image) {
          downloadBase64(result.data.image);
        } else {
          downloadBlob(blob);
        }
      } else {
        downloadBlob(blob);
      }
    } catch (error) {
      downloadBlob(blob);
    } finally {
      setIsDownloading(false);
    }
  };

  const downloadBase64 = (base64) => {
    const link = document.createElement('a');
    link.download = 'dary-voucher.png';
    link.href = 'data:image/png;base64,' + base64;
    link.click();
  };

  const downloadBlob = (blob) => {
    const link = document.createElement('a');
    link.download = 'dary-voucher.png';
    link.href = URL.createObjectURL(blob);
    link.click();
    URL.revokeObjectURL(link.href);
  };

  const handleShare = async () => {
    const shareUrl = 'https://dary.one/v/' + (voucherToken || code);
    
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'DARY Gift',
          text: parseFloat(amount).toFixed(2) + ' DAR',
          url: shareUrl
        });
        return;
      } catch (err) {}
    }
    
    navigator.clipboard.writeText(shareUrl);
    alert('Ссылка скопирована!');
  };

  return (
    <div className="voucher-card-wrapper">
      <div 
        className="voucher-card"
        style={{ backgroundImage: 'url(' + templateUrl + ')' }}
      >
        <div className="voucher-title">{title}</div>
        <div className="voucher-amount-box">
          <span className="voucher-amount">{parseFloat(amount).toFixed(2)}</span>
          <span className="voucher-currency">DAR</span>
        </div>
        <div className="voucher-branding">🎁 → dary.one</div>
        <div className="voucher-code">{code}</div>
      </div>

      <div className="voucher-actions">
        <button className="btn-share" onClick={handleShare}>Поделиться</button>
        <button className="btn-download" onClick={handleDownload} disabled={isDownloading}>
          {isDownloading ? '...' : 'Сохранить'}
        </button>
      </div>
    </div>
  );
};

export default VoucherCard;
